<div class="w-full h-[0px] border-t border-black border-opacity-10"></div>
